import { useState } from "react";

const fruits = [
  "Banana",
  "Apple",
  "Lemon",
  "Grape",
  "Watermelon",
  "Durian",
  "Jackfruit",
  "Orange",
  "Lime",
  "Melon",
  "Guava",
  "Cherry",
  "Raspberry",
  "Strawberry",
  "Mango",
];

export default function LoadMoreStaticData() {
  const [counter, setCounter] = useState(5);
  const incrementCounterValue = () => {
    if (counter < fruits.length) {
      setCounter(counter + 5);
    } else {
      setCounter(5);
    }
  };
  return (
    <div>
      <h3>Daftar Buah-Buahan</h3>
      <ul>
        {fruits.slice(0, counter).map((fruit, index) => (
          <li key={index}>{fruit}</li>
        ))}
      </ul>
      <button onClick={incrementCounterValue}>
        {counter === fruits.length ? "Show Less" : "Load More"}
      </button>
    </div>
  );
}
